import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import i18n from './vue_i18n'
import * as components from 'vuetify/components'
import * as labsComponents from 'vuetify/labs/components'
import * as directives from 'vuetify/directives'
import { en, no, fr, de } from 'vuetify/locale'
import { brands, detectBrand } from '../assets/brands'

const brandKey = detectBrand()
const brandConfig = brands[brandKey]

export const vuetify = createVuetify({
  components: {
    ...components,
    ...labsComponents
  },
  directives,
  lang: {
    locales: { en, no, fr, de },
    current: i18n.global.locale.value
  },
  theme: {
    defaultTheme: brandKey,
    themes: {
      kaia: brands.kaia.theme,
      novasense: brands.novasense.theme,
      kraftanmelding: brands.kraftanmelding.theme
    },
    typography: brandConfig.typography
  }
})

export default vuetify
